import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFilter } from '../../hooks'
import { sendStaffAppMetaData } from '../../eventTriggers'

export const CounselingHistory = () => {
  const { counseling_histories, config } = useSelector(state=>state)
  const [ filter, setFilter, Input ] = useFilter()
  const dispatch = useDispatch()

  function handleClick(resource) {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "counselingHistory",
        resource
      }
    })
    sendStaffAppMetaData(config.tab_default_meta_data.find(tab=>tab.detail == 'counseling_history').modal)
  }

  return(
    <>
      <Input {...{ filter, setFilter }}/>
      {
        counseling_histories.filter(counseling_history=>((counseling_history.title || '').toLowerCase().includes(filter.toLowerCase()))).map(counseling_history=>(
          <div key={counseling_history.id} onClick={()=>handleClick(counseling_history)} className="p-4 border-bottom clickable">
            <div className="d-flex justify-content-between align-items-center">
              <b>{ counseling_history.title }</b>
            </div>
            <div className="text-secondary pt-1">{ counseling_history.description }</div>
          </div>
        ))
      }
    </>
  )
}
